<script>
export default {
  created() {
    const homeDisabled = this.$store.state.store.data.feature_options?.pages?.home?.disabled || false;

    this.$store
      .dispatch('auth/logout')
      .then(() => {
        // Rediriger en utilisant Vue Router
        this.$router.push({ name: homeDisabled ? 'login' : 'home' });
      })
      .catch((error) => {
        console.error('Erreur lors de la déconnexion:', error);
        // En cas d'erreur, rediriger vers la page de connexion
        this.$router.push({ name: 'login' });
      });
  },
};
</script>

<template>
  <b-loading active />
</template>
